export const ROUTES = {
  dashboard: '/',
  login: '/login',
  cart: '/cart',
  parameters: '/parameters',
  orders: '/orders',
};
